import React from "react";
import "./PrivacyPolicy.css";
import NormalUserLayout from "../layouts/NormalUserLayout/NormalUserLayout";
import { useTranslation } from "react-i18next";

export const PrivacyPolicy = () => {
  const { t } = useTranslation("privacy");

  return (
    <NormalUserLayout>
      <div className="privacy-policy-container container">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10">
            <header className="text-center mb-5">
              <h1 className="privacy-policy__title">{t("privacy.header.title")}</h1>
            </header>

            {/* Subject */}
            <section className="mb-4">
              <h2 className="section-title">{t("privacy.sections.subject.title")}</h2>
              {t("privacy.sections.subject.paragraphs", { returnObjects: true }).map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </section>

            {/* Controller */}
            <section className="mb-4">
              <h2 className="section-title">{t("privacy.sections.controller.title")}</h2>
              {t("privacy.sections.controller.paragraphs", { returnObjects: true }).map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </section>

            {/* Browser Data */}
            <section className="mb-4">
              <h2 className="section-title">{t("privacy.sections.browserData.title")}</h2>
              {t("privacy.sections.browserData.paragraphs", { returnObjects: true }).map((p, i) => (
                <p key={i}>{p}</p>
              ))}
              <ul className="list-group list-group-flush mb-3">
                {t("privacy.sections.browserData.list", { returnObjects: true }).map((item, i) => (
                  <li key={i} className="list-group-item">
                    {item}
                  </li>
                ))}
              </ul>
              <p>{t("privacy.sections.browserData.legalBasis")}</p>
            </section>

            {/* Functional Cookies */}
            <section className="mb-4">
              <h2 className="section-title">{t("privacy.sections.functionalCookies.title")}</h2>
              {t("privacy.sections.functionalCookies.paragraphs", { returnObjects: true }).map(
                (p, i) => (
                  <p key={i}>{p}</p>
                )
              )}
            </section>

            {/* Your Request */}
            <section className="mb-4">
              <h2 className="section-title">{t("privacy.sections.yourRequest.title")}</h2>
              {t("privacy.sections.yourRequest.paragraphs", { returnObjects: true }).map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </section>

            {/* Invitation */}
            <section className="mb-4">
              <h2 className="section-title">{t("privacy.sections.invitation.title")}</h2>
              {t("privacy.sections.invitation.paragraphs", { returnObjects: true }).map((p, i) => (
                <p key={i}>{p}</p>
              ))}

              <p>
                <strong>{t("privacy.sections.invitation.kiServicesIntro")}</strong>
              </p>
              <ul className="list-group list-group-flush mb-3">
                {t("privacy.sections.invitation.kiServices", { returnObjects: true }).map(
                  (svc, i) => (
                    <li key={i} className="list-group-item">
                      {svc.name} –{" "}
                      <a href={svc.website} className="link-primary">
                        {svc.website}
                      </a>
                      ;{" "}
                      {t("privacy.sections.invitation.privacyPolicy", {
                        privacyPolicy: svc.privacyPolicy
                      })}
                    </li>
                  )
                )}
              </ul>
              <p>{t("privacy.sections.invitation.legalBasis")}</p>
            </section>

            {/* Business Relationship */}
            <section className="mb-4">
              <h2 className="section-title">{t("privacy.sections.businessRelationship.title")}</h2>
              {t("privacy.sections.businessRelationship.paragraphs", { returnObjects: true }).map(
                (p, i) => (
                  <p key={i}>{p}</p>
                )
              )}
              <p>{t("privacy.sections.businessRelationship.legalBasis")}</p>
            </section>

            {/* Web Conferences */}
            <section className="mb-4">
              <h2 className="section-title">{t("privacy.sections.webConferences.title")}</h2>
              {t("privacy.sections.webConferences.paragraphs", { returnObjects: true }).map(
                (p, i) => (
                  <p key={i}>{p}</p>
                )
              )}
              <ul className="list-group list-group-flush mb-3">
                {t("privacy.sections.webConferences.list", { returnObjects: true }).map(
                  (svc, i) => (
                    <li key={i} className="list-group-item">
                      {svc.name} –{" "}
                      <a href={svc.website} className="link-primary">
                        {svc.website}
                      </a>
                      ; Datenschutzhinweise:{" "}
                      <a href={svc.privacyPolicy} className="link-primary">
                        {svc.privacyPolicy}
                      </a>
                    </li>
                  )
                )}
              </ul>
              <p>{t("privacy.sections.webConferences.legalBasis")}</p>
            </section>

            {/* App Data */}
            <section className="mb-4">
              <h2 className="section-title">{t("privacy.sections.appData.title")}</h2>
              {/* Installation */}
              <h3 className="sub-section-title">
                {t("privacy.sections.appData.subsections.installation.title")}
              </h3>
              <p>{t("privacy.sections.appData.subsections.installation.paragraph")}</p>
              {/* Usage Data */}
              <h3 className="sub-section-title">
                {t("privacy.sections.appData.subsections.usageData.title")}
              </h3>
              {t("privacy.sections.appData.subsections.usageData.paragraphs", {
                returnObjects: true
              }).map((p, i) => (
                <p key={i}>{p}</p>
              ))}
              <ul className="list-group list-group-flush mb-3">
                {t("privacy.sections.appData.subsections.usageData.list", {
                  returnObjects: true
                }).map((item, i) => (
                  <li key={i} className="list-group-item">
                    {item}
                  </li>
                ))}
              </ul>
              <p>{t("privacy.sections.appData.subsections.usageData.legalBasis")}</p>

              {/* Permissions */}
              <h3 className="sub-section-title">
                {t("privacy.sections.appData.subsections.permissions.title")}
              </h3>
              {t("privacy.sections.appData.subsections.permissions.paragraphs", {
                returnObjects: true
              }).map((p, i) => (
                <p key={i}>{p}</p>
              ))}
              <ul className="list-group list-group-flush mb-3">
                {t("privacy.sections.appData.subsections.permissions.list", {
                  returnObjects: true
                }).map((item, i) => (
                  <li key={i} className="list-group-item">
                    {item}
                  </li>
                ))}
              </ul>
              <p>{t("privacy.sections.appData.subsections.permissions.legalBasis")}</p>
            </section>

            {/* Third-Party Services */}
            <section className="mb-4">
              <h2 className="section-title">{t("privacy.sections.thirdPartyServices.title")}</h2>
              {t("privacy.sections.thirdPartyServices.paragraphs", { returnObjects: true }).map(
                (p, i) => (
                  <p key={i}>{p}</p>
                )
              )}

              <h3 className="sub-section-title">
                {t("privacy.sections.thirdPartyServices.embedded.title")}
              </h3>
              <p>{t("privacy.sections.thirdPartyServices.embedded.paragraph")}</p>
              <ul className="list-group list-group-flush mb-3">
                {t("privacy.sections.thirdPartyServices.embedded.list", {
                  returnObjects: true
                }).map((item, i) => (
                  <li key={i} className="list-group-item">
                    {item}
                  </li>
                ))}
              </ul>

              <h3 className="sub-section-title">
                {t("privacy.sections.thirdPartyServices.analytics.title")}
              </h3>
              <p>{t("privacy.sections.thirdPartyServices.analytics.paragraph")}</p>
              <ul className="list-group list-group-flush mb-3">
                {t("privacy.sections.thirdPartyServices.analytics.list", {
                  returnObjects: true
                }).map((item, i) => (
                  <li key={i} className="list-group-item">
                    {item}
                  </li>
                ))}
              </ul>

              <h3 className="sub-section-title">
                {t("privacy.sections.thirdPartyServices.advertising.title")}
              </h3>
              {t("privacy.sections.thirdPartyServices.advertising.paragraphs", {
                returnObjects: true
              }).map((p, i) => (
                <p key={i}>{p}</p>
              ))}
              <ul className="list-group list-group-flush mb-3">
                {t("privacy.sections.thirdPartyServices.advertising.list", {
                  returnObjects: true
                }).map((item, i) => (
                  <li key={i} className="list-group-item">
                    {item}
                  </li>
                ))}
              </ul>

              <h3 className="sub-section-title">
                {t("privacy.sections.thirdPartyServices.push.title")}
              </h3>
              {t("privacy.sections.thirdPartyServices.push.paragraphs", {
                returnObjects: true
              }).map((p, i) => (
                <p key={i}>{p}</p>
              ))}
              <ul className="list-group list-group-flush mb-3">
                {t("privacy.sections.thirdPartyServices.push.list", { returnObjects: true }).map(
                  (svc, i) => (
                    <li key={i} className="list-group-item">
                      {svc.name} –{" "}
                      <a href={svc.website} className="link-primary">
                        {svc.website}
                      </a>
                      ; Datenschutzhinweise:{" "}
                      <a href={svc.privacyPolicy} className="link-primary">
                        {svc.privacyPolicy}
                      </a>
                    </li>
                  )
                )}
              </ul>
              <p>{t("privacy.sections.thirdPartyServices.push.legalBasis")}</p>
            </section>

            {/* Service Providers */}
            <section className="mb-4">
              <h2 className="section-title">{t("privacy.sections.serviceProviders.title")}</h2>
              {t("privacy.sections.serviceProviders.paragraphs", { returnObjects: true }).map(
                (p, i) => (
                  <p key={i}>{p}</p>
                )
              )}
            </section>

            {/* Your Rights */}
            <section className="mb-4">
              <h2 className="section-title">{t("privacy.sections.yourRights.title")}</h2>
              <p>{t("privacy.sections.yourRights.intro")}</p>
              <ul className="list-group list-group-flush mb-3">
                {t("privacy.sections.yourRights.list", { returnObjects: true }).map((item, i) => (
                  <li key={i} className="list-group-item">
                    {item}
                  </li>
                ))}
              </ul>
              <p>{t("privacy.sections.yourRights.withdrawal")}</p>
              <p>{t("privacy.sections.yourRights.advertisingObjection")}</p>
            </section>
          </div>
        </div>
      </div>
    </NormalUserLayout>
  );
};
